<template>
  <div>
    <Header></Header>
    <main id="content" role="main">
      <!-- Hero Section -->
      <div class="container space-top-3 space-bottom-2">
        <div class="w-lg-80 text-center mx-lg-auto">
          <div v-if="totalObj" class="mb-5 mb-md-11">
            <h2 class="display-4">{{ totalObj.title }}</h2>
            <p class="lead">{{ totalObj.subtitle }}</p>
          </div>
        </div>

        <!-- Gallery Section -->
        <div class="row mx-n2">
          <div
            v-if="sixImageList.length == 6 || sixImageList.length == 3"
            class="col-6 col-md px-2 mb-3"
          >
            <div
              class="h-250rem bg-img-hero"
              :style="
                'background-image: url(' + imgsrc + sixImageList[0] + ');'
              "
              alt=""
            />
          </div>
          <div
            v-if="sixImageList.length == 6 || sixImageList.length == 3"
            class="col-md-3 d-none d-md-block px-2 mb-3"
          >
            <div
              class="h-250rem bg-img-hero"
              :style="
                'background-image: url(' + imgsrc + sixImageList[1] + ');'
              "
              alt=""
            />
          </div>
          <div
            v-if="sixImageList.length == 6 || sixImageList.length == 3"
            class="col-6 col-md px-2 mb-3"
          >
            <div
              class="h-250rem bg-img-hero"
              :style="
                'background-image: url(' + imgsrc + sixImageList[2] + ');'
              "
              alt=""
            />
          </div>

          <div class="w-100"></div>

          <div
            v-if="sixImageList.length == 6"
            class="col-6 col-md px-2 mb-3 mb-md-0"
          >
            <div
              class="h-250rem bg-img-hero"
              :style="
                'background-image: url(' + imgsrc + sixImageList[3] + ');'
              "
              alt=""
            />
          </div>
          <div
            v-if="sixImageList.length == 6"
            class="col-md-4 d-none d-md-block px-2 mb-3 mb-md-0"
          >
            <div
              class="h-250rem bg-img-hero"
              :style="
                'background-image: url(' + imgsrc + sixImageList[4] + ');'
              "
              alt=""
            />
          </div>
          <div v-if="sixImageList.length == 6" class="col-6 col-md px-2">
            <div
              class="h-250rem bg-img-hero"
              :style="
                'background-image: url(' + imgsrc + sixImageList[5] + ');'
              "
              alt=""
            />
          </div>
        </div>
        <!-- End Gallery Section -->
      </div>
      <!-- End Hero Section -->

      <!-- Divider -->
      <div class="container">
        <div class="w-lg-100 mx-lg-auto">
          <hr class="my-0" />
        </div>
      </div>
      <!-- End Divider -->

      <!-- About Section -->
      <div class="container space-1">
        <div class="row justify-content-lg-between">
          <div v-if="totalObj" v-html="totalObj.content"></div>
        </div>
      </div>
      <!-- End About Section -->

      <!-- About Section -->
      <!-- <div class="container space-2">
        <div class="row justify-content-lg-between">
          <div class="col-lg-3 mb-4 mb-lg-0">
            <h2 v-if="cltclist&&cltclist.length>0">{{ this.cltclist[0].title }}</h2>
          </div>
          <div class="col-lg-8">
            <p v-if="cltclist&&cltclist.length>0" v-html="cltclist[0].content"></p>
          </div>
        </div>
      </div> -->
      <!-- End About Section -->
      <!-- FAQ Section -->
      <!-- <div class="container space-2">
        <div class="w-lg-100 mx-lg-auto">
          <div class="row">
            <div class="col-md-6 mb-3 mb-md-5">
              <div class="pr-md-4">
                <h4 v-if="cltclist&&cltclist.length>0">{{ cltclist[1].title }}</h4>
                <p v-if="cltclist&&cltclist.length>0" v-html="cltclist[1].content"></p>
              </div>
            </div>

            <div class="col-md-6 mb-3 mb-md-5">
              <div class="pl-md-4">
                <h4 v-if="cltclist&&cltclist.length>0">{{ this.cltclist[2].title }}</h4>
                <p v-if="cltclist&&cltclist.length>0" v-html="cltclist[2].content"> </p>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- End FAQ Section -->
      <!-- Divider -->
      <div class="container">
        <div class="w-lg-100 mx-lg-auto">
          <hr class="my-0" />
        </div>
      </div>
      <!-- End Divider -->

      <!-- Team Section -->
      <div class="container space-2">
        <!-- Title -->
        <div class="w-md-80 w-lg-60 text-center mx-md-auto mb-5 mb-md-9">
          <span class="d-block font-weight-bold text-cap mb-2">我们的团队</span>
          <h2>
            我们为客户提供基于数据可视化，云计算的软件、
            信息化技术支持和维护服务
          </h2>
        </div>
        <!-- End Title -->

        <div class="row mx-n2 mb-5">
          <!-- <div class="col-sm-6 col-lg-3 px-2 mb-3" v-for="item in teamList" :key="item.contentId">
            <div class="card h-100 transition-3d-hover">
              <div class="card-body">
                <div class="avatar avatar-lg avatar-circle mb-4">
                  <img
                    class="avatar-img"
                    :src="imgsrc + item.imgsrc"
                    alt="Image Description"
                  />
                </div>

                <span class="d-block small font-weight-bold text-cap mb-1"
                  >{{item.title}}</span
                >
                <h4 class="text-lh-sm">{{item.subtitle}}</h4>
                <p v-html="item.content" class="font-size-1">
                </p>
              </div>

              <div class="card-footer border-0 pt-0">
                <a class="btn btn-xs btn-soft-secondary" href="#">GO</a>
              </div>
            </div>
          </div> -->

          <div class="col-sm-6 col-lg-3 px-2 mb-3">
            <div class="card h-100 transition-3d-hover">
              <div class="card-body">
                <div class="avatar avatar-lg avatar-circle mb-4">
                  <img
                    class="avatar-img"
                    src="@/assets/img/160x160/001.png"
                    alt="Image Description"
                  />
                </div>

                <span class="d-block small font-weight-bold text-cap mb-1"
                  >WANGQUN</span
                >
                <h4 class="text-lh-sm">CEO</h4>
                <p class="font-size-1">
                  以梦为马，不负韶华！年轻的创联天成信息技术有限公司将助力新基建，为数字科学领域贡献力量。
                </p>
              </div>

              <div class="card-footer border-0 pt-0">
                <a class="btn btn-xs btn-soft-secondary" href="#">GO</a>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-lg-3 px-2 mb-3">
            <div class="card h-100 transition-3d-hover">
              <div class="card-body">
                <div class="avatar avatar-lg avatar-circle mb-4">
                  <img
                    class="avatar-img"
                    src="@/assets/img/160x160/002.png"
                    alt="Image Description"
                  />
                </div>

                <span class="d-block small font-weight-bold text-cap mb-1"
                  >AnQingTao</span
                >
                <h4 class="text-lh-sm">CFO</h4>
                <p class="font-size-1">
                  对一个人来说，所期望的不是别的，而仅仅是他能全力以赴和献身于一种美好事业。
                </p>
              </div>

              <div class="card-footer border-0 pt-0">
                <a class="btn btn-xs btn-soft-secondary" href="#">GO</a>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-lg-3 px-2 mb-3">
            <div class="card h-100 transition-3d-hover">
              <div class="card-body">
                <div class="avatar avatar-lg avatar-circle mb-4">
                  <img
                    class="avatar-img"
                    src="@/assets/img/160x160/003.png"
                    alt="Image Description"
                  />
                </div>

                <span class="d-block small font-weight-bold text-cap mb-1"
                  >WangCheng</span
                >
                <h4 class="text-lh-sm">Design Director</h4>
                <p class="font-size-1">
                  极致的数据美学，结合自研可视化技术，生动友好的呈现数据，为企业数据可视化助力！
                </p>
              </div>

              <div class="card-footer border-0 pt-0">
                <a class="btn btn-xs btn-soft-secondary" href="#">GO</a>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-lg-3 px-2 mb-3">
            <div class="card h-100 transition-3d-hover">
              <div class="card-body">
                <div class="avatar avatar-lg avatar-circle mb-4">
                  <img
                    class="avatar-img"
                    src="@/assets/img/160x160/004.png"
                    alt="Image Description"
                  />
                </div>

                <span class="d-block small font-weight-bold text-cap mb-1"
                  >你的席位</span
                >
                <h4 class="text-lh-sm">Join us</h4>
                <p class="font-size-1">
                  加入我们的团队，并成为我们的合伙人，一起创新创造未来！
                </p>
              </div>

              <div class="card-footer border-0 pt-0">
                <a class="btn btn-xs btn-soft-secondary" href="careers.html"
                  >GO</a
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Info -->
        <div class="text-center">
          <div
            class="
              d-inline-block
              font-size-1
              border
              bg-white
              text-center
              rounded-pill
              py-3
              px-4
            "
          >
            想和我们一起工作吗？<router-link
              class="font-weight-bold ml-3"
              to="/recruit"
              >我们正在招聘<span class="fas fa-angle-right fa-sm ml-1"></span
            ></router-link>
          </div>
        </div>
        <!-- End Info -->
      </div>
      <!-- End Team Section -->
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/vendor/jquery/dist/jquery.min.js"; //1
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js"; //2

import "@/assets/vendor/font-awesome/css/all.min.css"; //12
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css"; //13
// import "@/assets/css/front.css" //15
import "@/assets/css/theme.css"; //14
import "@/assets/vendor/hs-header/dist/hs-header.min.js"; //4
import "@/assets/vendor/hs-go-to/dist/hs-go-to.min.js"; //5
import "@/assets/vendor/hs-unfold/dist/hs-unfold.min.js"; //6
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js"; //7
import "@/assets/vendor/hs-show-animation/dist/hs-show-animation.min.js"; //8
import "@/assets/vendor/jquery-validation/dist/jquery.validate.min.js"; //9
import AOS from "aos";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; //3_type.scss
import "@/assets/js/hs.core.js"; //10
import "@/assets/js/hs.validation.js"; //11
import Header from "../components/header";
import Footer from "../components/footer";
import { getsycolumn, getsy, getsyres, getResouceInfo } from "../request/index";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      defautid: "",
      imgsrc: process.env.NODE_URL + "api/files/getFileStream?fileId=",
      botitle: "", // 博学标题
      bosubtitle: "", // 博学子标题
      bxlist: {
        one: null,
        two: null,
        three: null,
        four: null,
        five: null,
        six: null,
      }, // 博学6图
      cltclist: [], // 创联天成数组
      teamtitle: "", // 团队标题
      teamsubtitle: "", // 团队子标题
      teamList: [],
      totalObj: null,
      sixImageList: [],
    };
  },
  created() {
    getsycolumn(0).then((res) => {
      let arr = res.data;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].type == "企业简介") {
          getsy(arr[i].columnId).then((res) => {
            // this.getzy(res.data.content[0].contentId)
            this.totalObj = res.data.content[0];
          });
        }
      }
    });
    getResouceInfo({ type: 2 }).then((res) => {
      if (res.data.content.length > 0) {
        console.log(404, res.data.content[0].fileId.split(","));
        this.sixImageList = res.data.content[0].fileId.split(",");
      }
    });
  },
  methods: {
    getimg(a, b) {
      getsy(a).then((res) => {
        let arr = res.data.content;
        if (b) {
          arr.forEach((item) => {
            this.getzy(item.contentId, item);
          });
        } else {
          this.getzy(arr[0].contentId);
        }
      });
    },
    getzy(a, obj) {
      this.sixImageList = [];
      getsyres(a).then((res) => {
        let arr = res.data;
        if (obj) {
          if (arr && arr.length > 0) {
            arr.forEach((item) => {
              if (item.keystring == "头像") {
                obj.imgsrc = item.fileId;
                this.teamList.push(obj);
              }
            });
            if (this.teamList.length > 0) {
              console.log(351, this.teamList);
              this.teamList.sort((a, b) => {
                return a.tag - b.tag;
              });
            }
          }
        } else {
          for (let i = 0; i < arr.length; i++) {
            // if (arr[i].keystring == "博学图一") {this.bxlist.one = arr[i].fileId}
            // if (arr[i].keystring == "博学图二") {this.bxlist.two = arr[i].fileId}
            // if (arr[i].keystring == "博学图三") {this.bxlist.three = arr[i].fileId}
            // if (arr[i].keystring == "博学图四") {this.bxlist.four = arr[i].fileId }
            // if (arr[i].keystring == "博学图五") {this.bxlist.five = arr[i].fileId}
            // if (arr[i].keystring == "博学图六") {this.bxlist.six = arr[i].fileId }
            if (arr[i].keystring == "三六图") {
              this.sixImageList.push(arr[i]);
              this.sixImageList = this.sixImageList.sort((a, b) => {
                return b.tag - a.tag;
              });
            }
          }
        }
      });
    },
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
    $(document).ready(function () {
      console.log("aaa");
      //   console.log("ccccc",HSHeader)
      //   var header = new HSHeader($("#header")).init();
      console.log("bbb");

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($(".js-mega-menu"), {
        desktop: {
          position: "left",
        },
      }).init();

      // initialization of unfold
      var unfold = new HSUnfold(".js-hs-unfold-invoker").init();

      // initialization of fancybox
      $(".js-fancybox").each(function () {
        var fancybox = $.HSCore.components.HSFancyBox.init($(this));
      });

      // initialization of circles
      $(".js-circle").each(function () {
        var circle = $.HSCore.components.HSCircles.init($(this));
      });

      //initialization of aos
      AOS.init({
        duration: 650,
        once: true,
      });
      // initialization of go to
      $(".js-go-to").each(function () {
        var goTo = new HSGoTo($(this)).init();
      });
      $(".js-counter").each(function () {
        var counter = new HSCounter($(this)).init();
      });
    });
  },
};
</script>
<style scoped>
.display-4 {
  font-size: 3.5rem;
  font-weight: 600;
  line-height: 1.2;
}
.lead {
  font-size: 1.25rem;
  font-weight: 400;
  color: #677788;
}
.mb-lg-0 h2 {
  font-size: 1.875rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.col-lg-8 p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
  text-align: left;
}
.pr-md-4 h4 {
  font-size: 1.125rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.pr-md-4 p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
  text-align: left;
}
.pl-md-4 h4 {
  font-size: 1.125rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.pl-md-4 p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
  text-align: left;
}
.mb-2 {
  font-size: 1rem;
  line-height: 1.6;
  color: #677788;
}
.mb-md-9 h2 {
  font-size: 1.875rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.card-body span {
  line-height: 1.6;
  color: #677788;
  text-align: left;
}
.card-body h4 {
  font-size: 1.125rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}
.card-body p {
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
  text-align: left;
}
.font-weight-bold {
  font-weight: 600 !important;
  text-decoration: none;
}
.card-footer {
  background: #fff;
}
.card-footer .btn-soft-secondary {
  background: rgba(0, 0, 0, 0.03);
  font-size: 0.75rem;
  font-weight: 400;
  padding: 0.275rem 0.75rem;
  color: #71869d;
}
.card-footer .btn-soft-secondary:hover {
  color: #fff;
  background: #71869d;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>


// WEBPACK FOOTER //
// src/view/introduction.vue